import { render, staticRenderFns } from "./patientDetial.vue?vue&type=template&id=194a20f4&scoped=true&"
import script from "./patientDetial.vue?vue&type=script&lang=js&"
export * from "./patientDetial.vue?vue&type=script&lang=js&"
import style0 from "./patientDetial.vue?vue&type=style&index=0&id=194a20f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a20f4",
  null
  
)

export default component.exports